<template>
  <v-container>
    <v-card>
      <v-card-title>
        <v-icon left>mdi-clipboard-list-outline</v-icon>
        Reporte de Gestiones de Desarchivo
      </v-card-title>

      <v-card-text>
        <v-row align="center">
          <v-col cols="12" sm="3">
            <v-menu
              v-model="menuFechaDesde"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="fecha_desde"
                  label="Fecha desde"
                  prepend-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-on="on"
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fecha_desde"
                @input="menuFechaDesde = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="menuFechaHasta"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="fecha_hasta"
                  label="Fecha hasta"
                  prepend-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-on="on"
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fecha_hasta"
                @input="menuFechaHasta = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete
              v-model="gestor_id"
              :items="usuarios"
              item-text="name"
              item-value="id"
              label="Gestor"
              prepend-icon="mdi-account"
              clearable
              outlined
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-select
              v-model="tipoReporte"
              :items="tiposReporte"
              item-text="text"
              item-value="value"
              label="Tipo de reporte"
              prepend-icon="mdi-file-chart"
              outlined
              dense
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="3">
            <v-btn color="primary" @click="consultar" :loading="loading">
              <v-icon left>search</v-icon>
              Consultar
            </v-btn>
          </v-col>
          <v-col cols="12" sm="9" v-if="datos.length > 0" class="text-right">
            <v-btn color="success" @click="exportar('csv')" :loading="exportandoCsv" class="mr-2">
              <v-icon left>download</v-icon>
              CSV
            </v-btn>
            <v-btn color="green" dark @click="exportar('xlsx')" :loading="exportandoXlsx">
              <v-icon left>mdi-file-excel</v-icon>
              Excel
            </v-btn>
          </v-col>
        </v-row>

        <v-alert v-if="consultado && datos.length === 0" type="info" class="mt-4">
          Sin registros para los filtros seleccionados.
        </v-alert>

        <div v-if="datos.length > 0" class="mt-4">
          <!-- Tarjetas resumen -->
          <v-card outlined class="mb-4" v-if="tipoReporte === 'resumen'">
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <div class="headline">{{ totalGestiones }}</div>
                  <div class="caption">Total de gestiones</div>
                </v-col>
                <v-col cols="6">
                  <div class="headline">{{ totalSolicitudesUnicas }}</div>
                  <div class="caption">Solicitudes únicas atendidas</div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-text-field
            v-model="busqueda"
            label="Buscar dentro de resultados"
            prepend-icon="search"
            single-line
            hide-details
            class="mb-4"
          ></v-text-field>

          <v-data-table
            :headers="headersActivos"
            :items="datos"
            :search="busqueda"
            :items-per-page="15"
            class="elevation-1"
          >
            <template v-slot:item.estado_solicitud_nombre="{ item }">
              <v-chip :color="colorEstadoSolicitud(item.estado_solicitud)" small text-color="white">
                {{ item.estado_solicitud_nombre }}
              </v-chip>
            </template>
            <template v-slot:item.estado_desarchivo_nombre="{ item }">
              <v-chip :color="colorEstadoDesarchivo(item.estado_desarchivo)" small text-color="white" v-if="item.estado_desarchivo_nombre">
                {{ item.estado_desarchivo_nombre }}
              </v-chip>
              <span v-else class="grey--text">N/A</span>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'ReporteGestiones',
  data() {
    return {
      fecha_desde: null,
      fecha_hasta: null,
      gestor_id: null,
      tipoReporte: 'resumen',
      menuFechaDesde: false,
      menuFechaHasta: false,
      datos: [],
      busqueda: '',
      loading: false,
      exportandoCsv: false,
      exportandoXlsx: false,
      consultado: false,
      totalGestiones: 0,
      totalSolicitudesUnicas: 0,
      usuarios: [],
      tiposReporte: [
        { text: 'Resumen por gestor', value: 'resumen' },
        { text: 'Detalle de gestiones', value: 'detalle' },
      ],
      headersResumen: [
        { text: 'Gestor', value: 'gestor' },
        { text: 'Solicitudes Atendidas', value: 'solicitudes_atendidas' },
        { text: 'Total Gestiones', value: 'total_gestiones' },
      ],
      headersDetalle: [
        { text: 'ID Gestión', value: 'id' },
        { text: 'ID Solicitud', value: 'solicitud_desarchivo_id' },
        { text: 'Gestor', value: 'gestor' },
        { text: 'Estado Solicitud', value: 'estado_solicitud_nombre' },
        { text: 'Estado Desarchivo', value: 'estado_desarchivo_nombre' },
        { text: 'Radicado', value: 'radicado' },
        { text: 'Solicitante', value: 'solicitante' },
        { text: 'Juzgado Solicitante', value: 'juzgado_solicitante' },
        { text: 'Observación', value: 'observacion_gestion' },
        { text: 'Receptor', value: 'receptor' },
        { text: 'Fecha Estado Desarchivo', value: 'fecha_estado_desarchivo' },
        { text: 'Fecha Gestión', value: 'created_at' },
      ],
    };
  },
  computed: {
    headersActivos() {
      return this.tipoReporte === 'resumen' ? this.headersResumen : this.headersDetalle;
    },
  },
  created() {
    this.listar_usuarios();
  },
  methods: {
    listar_usuarios() {
      axios
        .get('/api/listar_usuarios')
        .then((response) => {
          this.usuarios = response.data.data || response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    paramsComunes() {
      const params = {};
      if (this.fecha_desde) params.fecha_desde = this.fecha_desde;
      if (this.fecha_hasta) params.fecha_hasta = this.fecha_hasta;
      if (this.gestor_id) params.gestor_id = this.gestor_id;
      return params;
    },
    consultar() {
      this.loading = true;
      const url = this.tipoReporte === 'resumen'
        ? '/api/reporte/gestiones/resumen'
        : '/api/reporte/gestiones/detalle';

      axios
        .get(url, { params: this.paramsComunes() })
        .then((response) => {
          this.datos = response.data.datos;
          if (this.tipoReporte === 'resumen') {
            this.totalGestiones = response.data.total_gestiones;
            this.totalSolicitudesUnicas = response.data.total_solicitudes_unicas;
          }
          this.consultado = true;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$alertify.error('Error al consultar el reporte');
        });
    },
    exportar(formato) {
      const base = this.tipoReporte === 'resumen'
        ? '/api/reporte/gestiones/export'
        : '/api/reporte/gestiones/export/detalle';

      const params = { ...this.paramsComunes(), formato };
      const mimeType = formato === 'csv'
        ? 'text/csv'
        : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      if (formato === 'csv') {
        this.exportandoCsv = true;
      } else {
        this.exportandoXlsx = true;
      }

      axios
        .get(base, { params, responseType: 'blob' })
        .then((response) => {
          const blob = new Blob([response.data], { type: mimeType });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          const sufijo = this.tipoReporte === 'resumen' ? 'resumen' : 'detalle';
          link.download = `reporte_gestiones_${sufijo}.${formato}`;
          link.click();
          this.exportandoCsv = false;
          this.exportandoXlsx = false;
        })
        .catch((error) => {
          this.exportandoCsv = false;
          this.exportandoXlsx = false;
          this.$alertify.error('Error al exportar');
        });
    },
    textoEstadoSolicitud(estado) {
      const map = { 1: 'Pendiente', 2: 'En trámite', 3: 'Realizada' };
      return map[estado] || estado;
    },
    textoEstadoDesarchivo(estado) {
      const map = { 1: 'En Búsqueda', 2: 'Paquete Errado', 3: 'En Oficina Judicial', 4: 'En Juzgado', 5: 'Devuelto a Archivo' };
      return map[estado] || estado;
    },
    colorEstadoSolicitud(estado) {
      const map = { 1: 'grey', 2: 'orange', 3: 'green' };
      return map[estado] || 'grey';
    },
    colorEstadoDesarchivo(estado) {
      const map = { 1: 'blue', 2: 'red', 3: 'purple', 4: 'indigo', 5: 'teal' };
      return map[estado] || 'grey';
    },
  },
};
</script>
